<template>
  <div class="wrap-sanger-box" v-if="showSanger">
    <div class="wrap-sanger-mask"></div>
    <div class="wrapContent">
      <div class="wrapAreaBox">
        <div class="warpArea">
          <el-row :gutter="30" class="warpAreaRow">
            <el-col :span="17">
              <div class="warpAreaLine">
                <p class="warpAreaFont">请输入取样备注信息</p>
              </div>
              <div class="fontBtnBox">
                <div class="fontStyle">仅填写本次送样相关信息，若无可不填写</div>
                <div class="fontBtn" @click="handelShow">知道了</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showSanger: false
    }
  },
  created() {
    let sangerMask = this.baseMethods.getLocalStr('sanger_mask')
    if (!sangerMask) {
      this.showSanger = true
      document.querySelector('body').setAttribute('style', 'overflow-y:hidden')
    }
  },
  mounted() {},
  methods: {
    handelShow() {
      this.showSanger = false
      this.baseMethods.setLocalStr('sanger_mask', 1)
      document.querySelector('body').removeAttribute('style')
    }
  }
}
</script>
<style scoped lang="scss">
  .wrap-sanger-box{
    width: 100%;
    height: 100%;
    .wrap-sanger-mask{
      position: fixed;
      top:0;
      left: 0;
      bottom: 0;
      right: 0;
      background: rgba(0,0,0,0.6);
      z-index: 1100;
    }
    .wrapContent{
      position: fixed;
      top:100px;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 1111;
      .wrapAreaBox{
        width: 1200px;
        margin: 0 auto;
        font-size: 14px;
        .warpArea{
          margin-top: 160px;
          .warpAreaRow{
            .warpAreaLine{
              border:1px solid #DCDFE6;
              height: 255px;
              background: #fff;
              border-radius: 4px;
              color: #ccc;
              .warpAreaFont{
                padding: 9px 15px;
              }
            }
            .fontBtnBox{
              width: 370px;
              height: 50px;
              margin-top: 25px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              background: #fff;
              border-radius: 5px;
              padding:0 15px;
              position: relative;
              &:after{
                position: absolute;
                top: -20px;
                left: 10%;
                content: ' ';
                width: 0;
                height: 0;
                border-bottom: 20px solid #fff;
                border-left: 6px solid transparent;
                border-right: 15px solid transparent;
                border-top: 0;
              }
              .fontBtn{
                width: 75px;
                height: 26px;
                line-height: 26px;
                color: #fff;
                text-align: center;
                cursor: pointer;
                border: none;
                background: #014492;
                border-radius: 13px;
              }
            }
          }
        }
      }
      @media screen  and (max-width: 640px){
        .wrapAreaBox{
          width: 90%;
          .warpArea{
            margin-top: 190px;
            .warpAreaLine{
              height: 270px;
            }
          }
        }
        .el-col-17{
          width: 100% !important;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/tec/order_sanger_mask.vue